import React, { forwardRef, useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { getAuth } from "firebase/auth";
import defaultImg from "../images/defaultimage.jpg";
import notificationIcon from "../images/icons/noti.svg";
import "../../index.css";
import { useSelector } from "react-redux";
import { parse } from "date-fns";

export const PetCard = forwardRef(({ data, qr, buscador, imageClick }, ref) => {
  //Redux store
  const petFormDataState = useSelector((state) => state.compartirMascota);
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const [notifIcon, setNotifIcon] = useState(false);
  const [razaName, setRazaName] = useState("");
  const [sexoName, setSexoName] = useState("");
  const [estadoName, setEstadoName] = useState("");
  const [differenceDays, setDifferenceDays] = useState(0);
  const date =
    typeof data.fecha_perdido === "string"
      ? parse(data.fecha_perdido, "dd/MM/yyyy", new Date())
      : null;

  useEffect(() => {
    const dataView = () => {
      const currentDate = new Date();
      if (data) {
        const raza = petFormDataState.raza.find((r) => r.id === data.raza);
        const estado = petFormDataState.estado.find(
          (r) => r.id === data.estado,
        );
        const sexo = petFormDataState.sexo.find((r) => r.id === data.sexo);
        raza ? setRazaName(raza.nombre) : setRazaName(data.raza);
        sexo ? setSexoName(sexo.nombre) : setSexoName(data.sexo);
        estado ? setEstadoName(estado.nombre) : setEstadoName(data.estado);
      }
      if (date) {
        const milisecondsDif = currentDate - date;
        const differenceDay = Math.floor(
          milisecondsDif / (1000 * 60 * 60 * 24),
        );
        setDifferenceDays(differenceDay);
      }
    };

    dataView();
  }, [data, date, petFormDataState]);

  useEffect(() => {
    if (currentUser !== null) {
      if (data.userId === currentUser.uid && data.en_contacto === true) {
        setNotifIcon(true);
      }
    }
  }, [currentUser, data]);

  const getCropStyle = () => {
    if (!data.crop || !data.zoom || !data.rotation) return {};

    const { crop, zoom, rotation } = data;

    // Ajustamos las propiedades de transformación usando los datos de crop y zoom
    return {
      transform: `translate(${crop.x}px, ${crop.y}px) scale(${zoom}) rotate(${rotation}deg)`,
      transformOrigin: "center center",
    };
  };

  return (
    <div
      ref={ref}
      className={`pet-card-size relative p-2 ${qr ? "" : "rounded-xl"}  ${
        estadoName || "Adopcion"
      } shadow-2xl  flex flex-col items-center ${buscador ? "" : ""}`}
    >
      <h1
        className={`${estadoName} z-10 absolute px-2 top-0 left-1/2 -translate-x-1/2 font-main font-bold text-2xl text-white uppercase rounded-b-xl`}
      >
        {estadoName || "Adopcion"}
      </h1>

      {qr ? (
        <div className="absolute p-1 rounded-md bg-white bottom-6 right-3 ">
          <QRCode
            value={`https://www.buscatuamigo.com/mascota/${data.id}`}
            className="w-14 h-14"
          />
        </div>
      ) : null}

      <div className="relative w-full">
        {data.foto ? (
          <div
            className="cursor-pointer image-card relative min-h-[270px] rounded-xl overflow-hidden"
            style={{
              backgroundImage: `url(${data.foto})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              ...getCropStyle(),
            }}
            onClick={imageClick}
          ></div>
        ) : (
          <img
            src={defaultImg}
            alt="Foto mascota"
            className="cursor-pointer image-card max-h-[260px] rounded-xl relative"
            onClick={imageClick}
          />
        )}
        <img
          src="/catw.webp"
          alt="Logo"
          className="absolute bottom-1 right-1 w-9 h-9"
        />
      </div>

      <div className="absolute left-3 top-3">
        {notifIcon ? <img src={notificationIcon} alt="Notification" /> : null}
      </div>

      <div className="w-full flex flex-col">
        <div className="flex justify-between">
          <h1
            className={`${
              estadoName || "Adopcion"
            }-Hard font-main font-bold text-2xl max-w-[380px] text-justify px-2`}
          >
            {data.nombre}
          </h1>
          {data.fecha_perdido ? (
            <span className="p-2 text-white font-main font-medium text-xs">
              {data.fecha_perdido}
            </span>
          ) : null}
        </div>

        <div className="relative flex px-2 gap-0 items-justify flex-col w-full h-full ">
          {data.raza ? (
            <span className="text-white font-main font-medium text-md pet-card-ts">
              {razaName}
            </span>
          ) : null}

          <div className="flex items-justify gap-2">
            {data.sexo ? (
              <span className="text-white font-main font-medium text-md pet-card-ts">
                {sexoName}
              </span>
            ) : null}
            <p className="text-white">-</p>
            {data.edad ? (
              <span className="text-white font-main font-medium pet-card-ts text-md">
                {estadoName !== "Adopcion"
                  ? data.edad >= 0 && data.edad <= 4
                    ? "Cachorro"
                    : data.edad > 4 && data.edad <= 8
                      ? "Joven"
                      : data.edad > 8
                        ? "Anciano"
                        : `${data.edad} años`
                  : `${data.edad} años`}
              </span>
            ) : null}
          </div>

          <div className="flex flex-col justify-center items-justify">
            {data.contacto ? (
              <span
                className={`${
                  estadoName || "Adopcion"
                }-Hard font-main font-bold text-xl`}
              >
                {data.contacto}
              </span>
            ) : null}
            {data.ciudad ? (
              <span className="text-white pet-card-ts font-medium font-main text-md text-justify w-full">
                {data.ciudad}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
});

export default PetCard;
